import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import { InvoiceType } from '@/core/domain/invoice/invoices/invoices.enums';
import formatterPrice from '@/utils/number/formatterPrice';
import formatterPriceTruncate from '@/utils/number/formatterPriceTruncate';
import { Col, Divider, Row, Statistic, Tooltip } from 'antd';

const InvoiceItemValues = () => {
  const {
    invoiceValues,
    invoice: { data },
    isNfe,
    isNfc,
    isNfs,
    isInternalApiIssued,
    useInternalInvoiceApiNfe,
    useInternalInvoiceApiNfc,
    useInternalInvoiceApiNfs,
  } = useInvoiceFormContext();

  const isNfeOrInternalApiNfe = isNfe && useInternalInvoiceApiNfe;
  const isNfcOrInternalApiNfc = isNfc && useInternalInvoiceApiNfc;
  const isNfsOrInternalApiNfs = isNfs && useInternalInvoiceApiNfs;
  const isApiConditionMet =
    isNfeOrInternalApiNfe ||
    isNfcOrInternalApiNfc ||
    isNfsOrInternalApiNfs ||
    isInternalApiIssued;

  const retentionPisCofins = data?.retentionPisCofins;

  const totalValueRetained =
    (isNfs ? invoiceValues?.totalPisWithheldValue || 0 : 0) +
    (isNfs ? invoiceValues?.totalCofinsWithheldValue || 0 : 0) +
    (isNfs ? invoiceValues?.totalCsllWithheldValue || 0 : 0) +
    (invoiceValues?.totalInssWithheldValue || 0) +
    (isNfs ? invoiceValues?.totalIrrfWithheldValue || 0 : 0) +
    (invoiceValues?.totalOtherWithholdings || 0);

  return (
    <>
      <Row gutter={[24, 24]}>
        <Col span={24} md={12} lg={6}>
          <Statistic
            title="Total itens"
            value={formatterPriceTruncate(
              isApiConditionMet
                ? invoiceValues?.totalItems || 0
                : (invoiceValues?.totalItems || 0) +
                    (invoiceValues?.totalDiscount || 0),
            )}
          />
        </Col>

        <Col span={24} md={12} lg={6}>
          <Statistic
            title="Total seguro"
            value={formatterPrice(invoiceValues?.totalSafe || 0)}
          />
        </Col>

        <Col span={24} md={12} lg={6}>
          <Statistic
            title="Total frete"
            value={formatterPrice(invoiceValues?.totalFreight || 0)}
          />
        </Col>

        <Col span={24} md={12} lg={6}>
          <Statistic
            title="Total despesas"
            value={formatterPrice(invoiceValues?.otherValue || 0)}
          />
        </Col>

        <Col span={24} md={12} lg={6}>
          <Statistic
            title="Total desconto"
            value={formatterPrice(invoiceValues?.totalDiscount || 0)}
          />
        </Col>

        {retentionPisCofins && (
          <Col span={24} md={12} lg={6}>
            <Statistic
              title="Pis/Cofins"
              value={formatterPrice(
                (invoiceValues?.totalCofinsWithheldValue || 0) +
                  (invoiceValues?.totalPisWithheldValue || 0),
              )}
            />
          </Col>
        )}

        {data?.invoiceType === InvoiceType.NFS && (
          <Col span={24} md={12} lg={6}>
            <Tooltip
              title={
                <>
                  <p>
                    {`PIS: ${formatterPrice(
                      invoiceValues?.totalPisWithheldValue || 0,
                    )}`}
                  </p>

                  <p>
                    {`COFINS: ${formatterPrice(
                      invoiceValues?.totalCofinsWithheldValue || 0,
                    )}`}
                  </p>

                  <p>
                    {`CSLL: ${formatterPrice(
                      invoiceValues?.totalCsllWithheldValue || 0,
                    )}`}
                  </p>

                  <p>
                    {`INSS: ${formatterPrice(
                      invoiceValues?.totalInssWithheldValue || 0,
                    )}`}
                  </p>

                  <p>
                    {`IRRF: ${formatterPrice(
                      invoiceValues?.totalIrrfWithheldValue || 0,
                    )}`}
                  </p>

                  <p>
                    {`CPP: ${formatterPrice(
                      invoiceValues?.totalCppWithheldValue || 0,
                    )}`}
                  </p>

                  <p>
                    {`Outros: ${formatterPrice(
                      invoiceValues?.totalOtherWithholdings || 0,
                    )}`}
                  </p>
                </>
              }
            >
              <Statistic
                title="Total retenções"
                value={formatterPrice(totalValueRetained || 0)}
              />
            </Tooltip>
          </Col>
        )}

        {data?.invoiceType === InvoiceType.NFS && (
          <Col span={24} md={12} lg={6}>
            <Statistic
              title="ISS retido"
              value={formatterPrice(invoiceValues?.totalWithheldValue || 0)}
            />
          </Col>
        )}

        <Col span={24} md={12} lg={6}>
          <Statistic
            title="Total nota fiscal"
            value={formatterPrice(
              (invoiceValues?.totalItems || 0) -
                (invoiceValues?.totalWithheldValue || 0) -
                (totalValueRetained || 0),
            )}
          />
        </Col>
      </Row>

      <Divider />
    </>
  );
};

export default InvoiceItemValues;
